module.exports = __webpack_public_path__ + "static/media/flyp_logo1.0c0428b2.png";